module.exports = __webpack_public_path__ + "static/media/pessoas.b00ca70a.svg";